export const validFlags = {
  // ALWAYS lowercase the first character.
  // cameraOffBlahBlah is good
  // CameraOffBlahBlah is BAD

  optumTermsAndConditions: false,
};

export type ValidFlags = typeof validFlags;
export type ValidFlag = keyof typeof validFlags;
